import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { DataGridPro, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import { fetchMicroexperienceList } from '../../Bundles/BundleApi';
import { BundleContext } from '../../Bundles/BundleContext';
import TagsFilter from 'Modules/Components/TagsFilter';
import { TagsContext } from 'Modules/Components/TagsContext';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import * as TagService from 'Services/TagService';

export default function MicroexperienceSelector({ onCardObjectSelected }) {
    return (
        <>
            <MicroexperienceList onCardObjectSelected={onCardObjectSelected} />
        </>
    );
}

function MicroexperienceList({ onCardObjectSelected }) {
    const [mxList, setMXList] = React.useState([]);
    const { getCardIdReferenceCount } = React.useContext(BundleContext)
    const [gridList, setGridList] = React.useState([]);


    React.useEffect(() => {
        (async () => {
            const data = await fetchMicroexperienceList() || [];
            setMXList(data);
        })();
    }, []);

    React.useEffect(() => {
        setGridList(mxList);
    }, [mxList])

    function selectRow(row) {       
        onCardObjectSelected(row);
    }

    function updateFilters(filters) {
        if (filters.tags && filters.tags.length) {
            const results = mxList.filter((mx) => {
                // the tags filter <Select> passes through and array of strings
                // in the form 'GroupName_tagid'
                // microexperience tags are an object keyd on group with an array of tag id integers
                if(mx.tags)
                return filters.tags.some((group_id) => {
                    if (!group_id) return null;
                    let [group, fid] = group_id.split('_');
                    return mx.tags[group]?.find((mxid) => mxid === parseInt(fid));
                });
                return null;
            });
            setGridList(results);
        }  else {
            setGridList(mxList);
        }
    }

    const columns = [
        {
            field: 'experienceImage',
            headerName: '',
            renderCell: (params) => <img alt="" src={params.value} style={{ height: '30px', width: '30px' }} />,
            flex: 0,
        },
        {
            field: 'id',
            headerName: 'MX ID',
            flex: 0,
            editable: false,
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0,
            editable : false,
        }, 
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            editable: false,
        },
        {
            field: 'contentType',
            headerName: 'Type',
            flex: 0,
            editable: false,
        },
        {
            field: 'effortSize',
            headerName: 'Size',
            flex: 0,
            editable: false,
        },
        {
            field: 'experienceLocation',
            headerName: 'Location',
            flex: 0,
            editable: false,
        },
        {
            field: 'refernceCount',
            headerName: 'Used',
            flex: 0,
            valueGetter : (params) => getCardIdReferenceCount(params.row.id)
        },        
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    selectRow(params.row);
                };

                return (
                    <Button variant="contained" color="primary" onClick={onClick}>
                        Assign
                    </Button>
                );
            },
        },
    ];

    return (
        <>
            <Box sx={{ flex: 1 }}>
                <DataGridPro
                    rows={gridList}
                    columns={columns}
                    pagination={true}
                    pageSize={10}
                    components={{ Toolbar: MicroexperienceGridToolbar }} 
                    componentsProps={{ toolbar : { updateFilters } }}
                    initialState={{
                        sorting: {
                            sortModel: [{ field: 'location', sort: 'desc' }],
                        },
                    }}

                    sx={{
                        '.MuiDataGrid-columnHeaders': {
                            fontWeight: 'bold',
                            fontSize: 14,
                            color: 'rgb(0,0,0)',
                            backgroundColor: 'rgb(244,246,248)',
                        },
                        '.MuiTablePagination-selectLabel': {
                            marginBottom: '0px',
                        },
                        '.MuiTablePagination-displayedRows': {
                            marginBottom: '0px',
                        },
                        '.MuiPaper-root.div.span': {
                            color: 'blue',
                        },
                    }}
                />
            </Box>
        </>
    );
}


function MicroexperienceGridToolbar({ updateFilters}) {
    const { tagGroups } = React.useContext(TagsContext);

    const [selectedTags, setSelectedTags] = React.useState([]);

    const initalState = { 
        tagGroups : TagService.TagGroupList,
        tagList : TagService.TagsInit,
    }   

    const [tagList, setTagList] = React.useState(initalState.tagList);
    React.useEffect(() => {
        (async () => {
            const tags = await TagService.getMicroExperienceTags();
            setTagList(tags);
        })();
    }, []);

    function tagsFilterChanged(val) {
        updateFilters({ tags: val });
        setSelectedTags(val);
    }

    
    return (
        <Box sx={{ display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center' }}>
            <GridToolbarContainer style={{ paddingTop: '10px' }}>
                <GridToolbarQuickFilter placeholder='Search Name...'/>
            </GridToolbarContainer>
            <Box sx={{ display : 'flex', width : '300px', alignItems : 'center'}}>
                <Typography sx={{ mr : 10}} >Tags</Typography>
            <TagsFilter onChange={tagsFilterChanged} value={selectedTags} tagGroups={tagGroups} tagList={tagList} />
            </Box>
        </Box>
    );
}